// pwa.ts - Datos de la app instalable ("Agregar a pantalla de inicio") por empresa.
// manifest.json es genérico; aquí se reemplaza por uno con el nombre, color e ícono
// de la empresa del subdominio, para que en el celular aparezca como "ITOBOX" y no
// como "Courier".

interface PwaBrand {
    subdomain: string;
    companyName: string;
    themeColor: string;
}

// Empresas con íconos propios en public/icons/<subdominio>/
const ICON_SETS = new Set(['itobox']);

const setMeta = (name: string, content: string) => {
    let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
    if (!el) {
        el = document.createElement('meta');
        el.name = name;
        document.head.appendChild(el);
    }
    el.content = content;
};

const setLink = (rel: string, href: string) => {
    let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
    if (!el) {
        el = document.createElement('link');
        el.rel = rel;
        document.head.appendChild(el);
    }
    el.href = href;
};

/** Ícono de la empresa dibujado por el servidor (su logo, o sus iniciales sobre su color) */
export const tenantIconUrl = (size: 180 | 192 | 512) =>
    `/api/tenants/icon?host=${encodeURIComponent(window.location.hostname)}&size=${size}`;

/** Nombre corto para debajo del ícono (las pantallas de inicio cortan ~12 letras) */
const shortName = (name: string) => {
    const clean = name.replace(/\s+(courier|cargo|express|s\.?a\.?|srl|ltda)\.?$/i, '').trim();
    return (clean.length <= 12 ? clean : clean.split(/\s+/)[0]).slice(0, 12) || 'Courier';
};


export function applyPwaBranding({ subdomain, companyName, themeColor }: PwaBrand) {
    if (typeof document === 'undefined') return;
    const origin = window.location.origin;
    const base = ICON_SETS.has(subdomain) ? `/icons/${subdomain}` : '/icons';
    const name = companyName || 'Sistema Courier';
    const short = shortName(name);
    const color = /^#[0-9a-f]{3,8}$/i.test(themeColor) ? themeColor : '#111111';

    setMeta('theme-color', color);
    setMeta('apple-mobile-web-app-title', short);
    // Ícono del iPhone: el de ITOBOX, o el que dibuja el servidor con el logo de la empresa
    setLink('apple-touch-icon', ICON_SETS.has(subdomain) ? `${base}/apple-touch-icon.png` : tenantIconUrl(180));
    if (ICON_SETS.has(subdomain)) {
        const icon = document.querySelector('link[rel="icon"]') as HTMLLinkElement | null;
        if (icon) { icon.type = 'image/png'; icon.href = `${base}/favicon-32.png`; }
    }

    // Empresas con íconos propios traen su manifest.json fijo (lo más confiable al instalar)
    if (ICON_SETS.has(subdomain)) {
        setLink('manifest', `${base}/manifest.json`);
        return;
    }

    // Las demás (empresas nuevas y dominios propios): el servidor entrega su ficha real con
    // nombre y color (/api/tenants/manifest; Vercel reenvía /api al servidor, mismo dominio).
    // Antes se armaba aquí en un blob y Chrome en Android no siempre la aceptaba para instalar.
    if (typeof window !== 'undefined') {
        setLink('manifest', `/api/tenants/manifest?host=${encodeURIComponent(window.location.hostname)}`);
    }
}
